import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../hooks'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  getFormikSelectFieldNextValue,
  getFormikSelectFieldValueProps,
} from '../../../Formik'
import { InputField } from '../../../Input'
import { InputSelect } from '../../../Select'
import { TextareaInlineField } from '../../../Textarea'
import {
  APPOINTMENT_REMINDER_OPTIONS,
  APPOINTMENT_TYPE_OPTIONS,
} from '../../Appointment.constants'
import {
  APPOINTMENT_FORM_DESCRIPTION_MIN_ROWS,
  APPOINTMENT_FORM_FIELD_NAME,
  APPOINTMENT_FORM_LOCATION_MAX_LENGTH,
  APPOINTMENT_FORM_TITLE_MAX_LENGTH,
} from '../AppointmentFormModal.constants'
import { getAppointmentFormTranslatedOptions } from '../AppointmentFormModal.utils'

import { AppointmentFormModalAnchorFields } from './AppointmentFormModalAnchorFields'
import { AppointmentFormModalHintedControl } from './AppointmentFormModalHintedControl'
import { AppointmentFormModalParticipantsField } from './AppointmentFormModalParticipantsField'
import { AppointmentFormModalTimeFields } from './AppointmentFormModalTimeFields'

function AppointmentFormModalFields({ requestIds }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const typeOptions = getAppointmentFormTranslatedOptions({
    options: APPOINTMENT_TYPE_OPTIONS,
    t,
  })

  const reminderOptions = getAppointmentFormTranslatedOptions({
    options: APPOINTMENT_REMINDER_OPTIONS,
    t,
  })

  const selectControlProps = {
    borderless: !isMobileScreenSize,
    indicatorsProps: { ButtonClear: null },
  }

  return (
    <FormFieldsContainer>
      <FormikField
        hasCounter
        Component={InputField}
        borderless={!isMobileScreenSize}
        fieldComponentProps={{
          label: `${t('Appointment.FormTitleLabelKey')}:`,
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        maxLength={APPOINTMENT_FORM_TITLE_MAX_LENGTH}
        name={APPOINTMENT_FORM_FIELD_NAME.title}
      />
      <AppointmentFormModalTimeFields />
      <FormikField
        Component={FormFieldSelectNG}
        Select={InputSelect}
        controlProps={selectControlProps}
        fieldComponentProps={{
          label: `${t('Appointment.FormTypeLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        getNextValue={getFormikSelectFieldNextValue}
        getValueProps={getFormikSelectFieldValueProps(typeOptions)}
        name={APPOINTMENT_FORM_FIELD_NAME.type}
        options={typeOptions}
      />
      <AppointmentFormModalAnchorFields requestIds={requestIds} />
      <FormikField
        clearable
        Component={InputField}
        borderless={!isMobileScreenSize}
        fieldComponentProps={{
          label: `${t('Appointment.FormLocationLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        maxLength={APPOINTMENT_FORM_LOCATION_MAX_LENGTH}
        name={APPOINTMENT_FORM_FIELD_NAME.location}
      />
      <AppointmentFormModalParticipantsField />
      <FormikField
        Component={AppointmentFormModalHintedControl}
        Control={TextareaInlineField}
        borderless={!isMobileScreenSize}
        fieldComponentProps={{
          label: `${t('Appointment.FormDescriptionLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        hint={t('Appointment.FormDescriptionHintKey')}
        minRows={APPOINTMENT_FORM_DESCRIPTION_MIN_ROWS}
        name={APPOINTMENT_FORM_FIELD_NAME.description}
      />
      <FormikField
        Component={AppointmentFormModalHintedControl}
        Control={FormFieldSelectNG}
        Select={InputSelect}
        controlProps={selectControlProps}
        fieldComponentProps={{
          label: `${t('Appointment.FormReminderLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        getNextValue={getFormikSelectFieldNextValue}
        getValueProps={getFormikSelectFieldValueProps(reminderOptions)}
        hint={t('Appointment.FormReminderHintKey')}
        name={APPOINTMENT_FORM_FIELD_NAME.reminder}
        options={reminderOptions}
      />
    </FormFieldsContainer>
  )
}

export default AppointmentFormModalFields
